import { Button, Heading, Link, Text } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';

interface TermsOfUseProps {
    goToNextStep: () => void;
    userName: string;
}

export function TermsOfUse(props: Readonly<TermsOfUseProps>) {
    const translate = getSelectedLanguage();

    return (
        <>
            <Heading>Account activeren</Heading>
            <Text>
                Welkom, <b>{props.userName}</b>.
            </Text>
            <Text>
                Om een optimale en veilige samenwerking binnen het Ksyos platform te kunnen waarborgen, zijn er
                gebruikersvoorwaarden voor individuele zorgverleners opgesteld. Je kunt deze voorwaarden{' '}
                <Link
                    color="secondary"
                    href="https://ksyos.nl/gebruikersvoorwaarden-zorgverleners/"
                    target="_blank"
                    variant="externalLink"
                >
                    hier
                </Link>{' '}
                lezen.
            </Text>
            <Text>De gebruikersvoorwaarden zijn van toepassing zodra je je account hebt geactiveerd.</Text>
            <Button
                color="secondary"
                onClick={props.goToNextStep}
                width="full"
            >
                {translate.common.next}
            </Button>
        </>
    );
}
